/*
 * @Date: 2021-03-11 10:59:16
 * @Description: Icon/index.js
 */
import Icon from './index.vue';

export default {
    install(vue) {
        const requireAll = function (context) {
            return context.keys().map(context);
        };
        const webpackRequire = require.context('@/assets/icons_g', false, /\.svg$/);
        requireAll(webpackRequire);
        vue.component('b-icon', Icon);
    }
};
